type GetUserFullNameProps = {
  firstname: string;
  lastname: string;
};

export const getUserFullName = (user: GetUserFullNameProps) => `${user.firstname} ${user.lastname}`;
